import Duperswiper from './Duperswiper';
import DuperswiperContainer from './Duperswiper.container';
export default DuperswiperContainer(Duperswiper);
//# sourceMappingURL=index.js.map